<div mat-dialog-title class="title">
    <span class="heading">Audit Log</span>
    @if(isDialogOpen)
    {
        <div class="title-actions">
            <button mat-icon-button (click)="openInNewTab()" class="new-tab">
                <mat-icon>open_in_new</mat-icon>
            </button>
            <button mat-dialog-close mat-icon-button>
                <mat-icon class="close-icon-color">cancel</mat-icon>
            </button>
        </div>
    }
</div>

<div mat-dialog-content>
    <mat-tab-group class="audit-tab" animationDuration="0ms" [disableRipple]="true">

        <mat-tab label="Details">
            <div [ngClass]="{
                    'tab-content-wrapper': isDialogOpen,
                    'extended-tab-content-wrapper': !isDialogOpen
                }">
                <form [formGroup]="form" class="form-content">
                    <mat-form-field>
                        <mat-label>Request id</mat-label>
                        <input readonly matInput formControlName="requestId" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Request type</mat-label>
                        <input readonly matInput formControlName="requestType" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Stage</mat-label>
                        <input readonly matInput formControlName="stage" />
                    </mat-form-field>
                    <div class="date-time-row">
                        <mat-form-field color="accent" class="date-field">
                            <mat-label>Transaction date</mat-label>
                            <input matInput
                                   [matDatepicker]="picker2"
                                   formControlName="transactionDate" />
                            <mat-datepicker-toggle [disabled]="true" matSuffix color="mat-accent"
                                                   [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field color="accent" class="time-field">
                            <mat-label>Transaction Time</mat-label>
                            <input matInput
                                   type="time"
                                   formControlName="transactionTime" />
                        </mat-form-field>
                    </div>
                    <mat-form-field color="accent">
                        <mat-label>Updated date</mat-label>
                        <input matInput
                               [matDatepicker]="picker1"
                               formControlName="updatedDate" />
                        <mat-datepicker-toggle [disabled]="true" matSuffix color="mat-accent"
                                               [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Updated by</mat-label>
                        <input readonly matInput formControlName="updatedBy" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Amount</mat-label>
                        <input readonly matInput formControlName="amount" appCurrencyInput />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Matter number</mat-label>
                        <input readonly matInput formControlName="matterNumber" />
                    </mat-form-field>
                    <mat-form-field *ngIf="form.get('requestType')?.value !== RequestType.Journal">
                        <mat-label>Matter Name</mat-label>
                        <input readonly matInput formControlName="matterName" />
                    </mat-form-field>
                    <mat-form-field *ngIf="form.get('requestType')?.value === RequestType.Journal">
                        <mat-label>Matter From</mat-label>
                        <input readonly matInput formControlName="matterFrom" />
                    </mat-form-field>
                    <mat-form-field *ngIf="form.get('requestType')?.value === RequestType.Journal">
                        <mat-label>Matter To</mat-label>
                        <input readonly matInput formControlName="matterTo" />
                    </mat-form-field>
                    <mat-form-field *ngIf="form.get('requestType')?.value !== RequestType.Journal">
                        <mat-label>Client Name</mat-label>
                        <input readonly matInput formControlName="clientName" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Approval status</mat-label>
                        <input readonly matInput formControlName="approvalStatus" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>RPA Status</mat-label>
                        <input readonly matInput formControlName="wasRpaSuccessfull" />
                    </mat-form-field>
                    @if (showFailureReason) {
                        <mat-form-field class="fullLength">
                            <mat-label>Failure reason</mat-label>
                            <textarea matInput formControlName="failureReason"></textarea>
                        </mat-form-field>
                    }
                </form>
            </div>
        </mat-tab>

        <mat-tab label="Attachments" [disabled]="!hasAttachments">
            <div [ngClass]="{
                        'tab-content-wrapper': isDialogOpen,
                        'extended-tab-content-wrapper': !isDialogOpen
                      }">
                <xp-attachment-list *ngIf="hasAttachments" [attachments]="attachments" />
            </div>
        </mat-tab>

        <mat-tab label="Audit">
            <xp-audit-log [ngClass]="{
                    'dialog-mode': isDialogOpen,
                    'extended-mode-audit': !isDialogOpen
                }" *ngIf="data" [requestId]="requestInfo.requestId" [requestType]="requestInfo.requestType" />
        </mat-tab>

    </mat-tab-group>
</div>
